export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";